import { InvoiceModelV3 } from '@frontend/api-invoices';
import { CollectPaymentMultiModalInstance } from '../collect-payment-multi';
import { UsePaymentsModalButtonReturnType } from '../hooks';
import { CreateAndCollectModal } from './create-and-collect-modal';
import { OnInvoiceCreated } from './create-payment-request-modal';

type PaymentRequestModalProps = UsePaymentsModalButtonReturnType['paymentRequestModalProps'] & {
  onInvoiceCreated?: OnInvoiceCreated;
  redirectToInvoiceDetailPage?: (invoiceId: InvoiceModelV3) => void;
};

export const PaymentRequestModal = ({
  showMultiProcessorCollect,
  Tooltip,
  onInvoiceCreated,
  redirectToInvoiceDetailPage,
  ...rest
}: PaymentRequestModalProps) => {
  return (
    <>
      {/*disabled is not added as a condition to not break existing code like usePaymentAction*/}
      {showMultiProcessorCollect ? (
        <CollectPaymentMultiModalInstance
          modalProps={rest}
          collectProps={{
            flow: 'create',
          }}
        />
      ) : (
        <CreateAndCollectModal
          {...rest}
          onInvoiceCreated={onInvoiceCreated}
          redirectToInvoiceDetailPage={redirectToInvoiceDetailPage}
        />
      )}
      {Tooltip}
    </>
  );
};
